import { FontAwesome5 } from '@expo/vector-icons';
import { styled, useDimension } from '@openeducation/oe-it-themes';
import React from 'react';
import type { StyleProp, ViewStyle } from 'react-native';

import { OEText } from '../../atoms/oe-text/oe-text';

type PaginatedHeaderArrowButtonProps = {
  iconLeft?: string;
  iconRight?: string;
  disabled?: boolean;
  style?: StyleProp<ViewStyle>;
  onPress: () => void;
  children?: React.ReactNode;
};
export const PaginatedHeaderArrowButton: React.FC<
  PaginatedHeaderArrowButtonProps
> = ({ iconLeft, iconRight, onPress, disabled = false, style, children }) => {
  const { isMobile } = useDimension();

  return (
    <Button onPress={onPress} disabled={disabled} style={style}>
      {iconLeft && <Icon name={iconLeft} disabled={disabled} />}
      {!isMobile && (
        <StyledText disabled={disabled} selectable={false}>
          {children}
        </StyledText>
      )}

      {iconRight && <Icon name={iconRight} disabled={disabled} />}
    </Button>
  );
};

const Button = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
`;

const StyledText = styled(OEText)<{ disabled: boolean }>`
  font-size: 12px;
  text-transform: uppercase;
  color: ${({ disabled, theme }) =>
    disabled ? theme.color.dark3 : theme.color.dark1};
`;

const Icon = styled(FontAwesome5).attrs(() => ({
  size: 16,
}))<{ disabled: boolean }>`
  margin-left: 8px;
  margin-right: 8px;
  color: ${({ disabled, theme }) =>
    disabled ? theme.color.dark3 : theme.color.dark1};
`;
